import React from 'react'
import classnames from 'classnames'

interface SecurityIconProps {
  className?: string
}

const SecurityIcon: React.FC<SecurityIconProps> = ({ className = '' }) => {
  return (
    <svg
      className={classnames('icon--security-icon-props', {
        [className]: !!className,
      })}
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="15"
      viewBox="0 0 13 15"
      fill="none"
    >
      <path
        d="M12.1941 3.44249L6.47806 0.0702686C6.31921 -0.0234229 6.12136 -0.0234229 5.9625 0.0702686L0.246419 3.44249C0.0936516 3.53263 0 3.69593 0 3.87221V5.79722C0 9.85174 2.36226 13.5549 6.03822 14.9663C6.15524 15.0112 6.28517 15.0113 6.40231 14.9663C10.0693 13.5584 12.4405 9.86328 12.4405 5.79722V3.87221C12.4405 3.6959 12.3469 3.53263 12.1941 3.44249ZM8.71125 6.37645L5.55117 9.51023C5.35427 9.70549 5.03503 9.70549 4.83812 9.51023L3.72908 8.41045C3.53217 8.21521 3.53217 7.8986 3.72908 7.70334C3.92598 7.50811 4.24525 7.50811 4.44213 7.70334L5.19462 8.44956L7.9982 5.66934C8.19507 5.47411 8.51435 5.47411 8.71125 5.66934C8.90818 5.86464 8.90818 6.18122 8.71125 6.37645Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SecurityIcon
